import React, { useRef, useEffect, useState } from "react";
import "./BodyMembersCard.css";
import img1 from "../../assets/Committee/president-img.jpg";
import img2 from "../../assets/Committee/vicepresident-img.jpg";
import img3 from "../../assets/Committee/tresurer-img.jpg";
import img4 from "../../assets/Committee/secretary-img.jpg";
import img5 from "../../assets/Committee/ladiespresident-img.jpg";

const BodyMembersCard = () => {
  const cardData = [
    { title: "PRESIDENT", img: img1, description: "Dr. Rajan Phutane" },
    { title: "VICE PRESIDENT", img: img2, description: "Dr. Arun Patil" },
    { title: "TREASURER", img: img3, description: "Dr. Kuldeep Patil" },
    { title: "SECRETARY", img: img4, description: "Dr. Pradip Vaske" },
    { title: "LADIES PRESIDENT", img: img5, description: "Dr. Vaishali Lokhande" },
  ];

  return (
    <div className="body-members-card">
      <div className="title">
        <h4 className="committee-title">COMMITTEE</h4>
        <div className="title-underline"></div>
      </div>
      <div className="card-scroller">
        <div className="card-container">
          {cardData.map((card, index) => (
            <div className="card" key={index}>
              <div className="img-border">
                <img src={card.img} alt={card.title} />
              </div>
              <h2>{card.title}</h2>
              <p>{card.description}</p>
            </div>
          ))}
          {/* Duplicate the content for seamless scrolling */}
          {cardData.map((card, index) => (
            <div className="card duplicate" key={`duplicate-${index}`}>
              <div className="img-border">
                <img src={card.img} alt={card.title} />
              </div>
              <h2>{card.title}</h2>
              <p>{card.description}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BodyMembersCard;
